import { useLoaderData } from "@remix-run/react";
import invariant from "tiny-invariant";
import apiClient from "~/api/axios.server";
import { ArticleDescriptionLayout, ProfessionalArticleTabs } from "~/screens";
import type { ArticleData } from "~/types";
//@ts-ignore
import type { LinksFunction, V2_MetaFunction } from "@remix-run/node";
import articlegallerystyle from "~/screens/articles/style/article_image.css";
import config from "~/config.server";

export const links: LinksFunction = () => {
  return [{ rel: "stylesheet", href: articlegallerystyle }];
};

export const loader = async ({ request, params }: any) => {
  invariant(params.articleId, `params.articleId is required`);
  const cliend = apiClient();
  const { articleId } = params;

  try {
    const response = await cliend.get<ArticleData>(
      `/specialist_articles/${Number(articleId)}`
    );

    const { data } = response;

    return {
      ...data,
      baseUrl: config.BASEURL,
    };
  } catch (error: any) {
    // console.log("🚀 ~ loader ~ error:", error);

    throw new Error(String(error?.response?.data?.message || error.message));
  }
};

export const meta: V2_MetaFunction<typeof loader> = ({
  data,
}: {
  data: ArticleData;
}) => {
  if (!data || !data.metaInfo) return [];
  const { metaInfo } = data;

  const metaTags: any[] = [
    { title: metaInfo.title },
    {
      property: "og:title",
      content: metaInfo.ogTitle,
    },
    { property: "og:description", content: metaInfo.ogDescription },
    {
      name: "description",
      content: metaInfo.description,
    },
  ];

  // Only add canonical if it exists
  if (metaInfo.canonical) {
    metaTags.push({
      property: "og:url",
      content: metaInfo.canonical,
    });
  }

  // Only add og:image if it exists
  if (metaInfo.ogImage) {
    metaTags.push({
      property: "og:image",
      content: `${data.baseUrl}/${metaInfo.ogImage}`,
    });
  }

  return metaTags;
};

export default function ProfessionalArticleDetail() {
  const data = useLoaderData<ArticleData>();
  // console.log("🚀 ~ ProfessionalArticleDetail ~ data:", data);

  return (
    <div className="section-wrapper">
      <ArticleDescriptionLayout {...data} />
      <ProfessionalArticleTabs {...data} />
    </div>
  );
}
